import {
  GROUPS_BY_ALIAS_MAP,
  PARTICIPANTS_BY_ALIAS_MAP,
} from '@/store/getterTypes';

export default {
  [PARTICIPANTS_BY_ALIAS_MAP](state) {
    return Object.fromEntries(
        Object.entries(state.participantsById)
            .map(([_, participant]) => [participant.alias, participant]) || [],
    );
  },
  [GROUPS_BY_ALIAS_MAP](state) {
    return Object.fromEntries(
        state.participantGroups
            .map((group) => [group.alias, group]) || [],
    );
  },
};
